import React from "react";
import ReactDOM from "react-dom/client";
import App, { scannedTableNumberFromLocation, tableLink } from "./App";
import "./styles.css";

const scannedTableNumber = scannedTableNumberFromLocation();
const isLegacyAdminTableQr = window.location.pathname.replace(/\/+$/, "") === "/admin" && Boolean(scannedTableNumber);

if (isLegacyAdminTableQr) {
  window.location.replace(tableLink(scannedTableNumber));
} else {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
